/** The heart, as an inline SVG so it inherits `currentColor`. */
export function HeartMark({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <svg className={`heart-mark ${className}`} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M16 27s-11-6.9-11-14.6A6 6 0 0 1 16 9a6 6 0 0 1 11 3.4C27 20.1 16 27 16 27z" fill="currentColor" />
    </svg>
  );
}

export function Icon({ name, size = 22 }: { name: 'home' | 'health' | 'coach' | 'rewards' | 'profile' | 'plus' | 'chat' | 'phone' | 'alert' | 'check' | 'bell' | 'pill' | 'steps' | 'watch' | 'gift' | 'shield' | 'target' | 'trend' | 'back' | 'close' | 'star' | 'doc' | 'device' | 'coin'; size?: number }) {
  const common = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true };
  switch (name) {
    case 'home':
      return (
        <svg {...common}>
          <path d="M3 11 12 3l9 8v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z" />
        </svg>
      );
    case 'health':
    case 'trend':
      return (
        <svg {...common}>
          <path d="M3 12h4l2-6 4 12 2-6h6" />
        </svg>
      );
    case 'coach':
    case 'chat':
      return (
        <svg {...common}>
          <path d="M4 5h16v11H8l-4 4z" />
          <path d="M8 9h8M8 12h5" />
        </svg>
      );
    case 'rewards':
    case 'gift':
      return (
        <svg {...common}>
          <path d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12M8.5 9C7 9 6 8 6 6.5S7.5 4 9 5c1.5 1 3 4 3 4s1.5-3 3-4c1.5-1 3 .5 3 1.5S17 9 15.5 9" />
        </svg>
      );
    case 'profile':
      return (
        <svg {...common}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
        </svg>
      );
    case 'plus':
      return (
        <svg {...common}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case 'phone':
      return (
        <svg {...common}>
          <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
        </svg>
      );
    case 'alert':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v6M12 16.5v.5" />
        </svg>
      );
    case 'check':
      return (
        <svg {...common}>
          <path d="M5 12.5 10 17l9-10" />
        </svg>
      );
    case 'bell':
      return (
        <svg {...common}>
          <path d="M6 16V11a6 6 0 1 1 12 0v5l2 2H4zM10 21h4" />
        </svg>
      );
    case 'pill':
      return (
        <svg {...common}>
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6.5 6.5l2.8 2.8M14.7 14.7l2.8 2.8M6.5 17.5l2.8-2.8M14.7 9.3l2.8-2.8" />
        </svg>
      );
    case 'steps':
      return (
        <svg {...common}>
          <path d="M7 3c2 0 3 2 3 5s-1 5-3 5-3-2-3-5 1-5 3-5zM17 6c2 0 3 2 3 5s-1 5-3 5-3-2-3-5 1-5 3-5zM6 15h2v5H6zM16 18h2v3h-2z" />
        </svg>
      );
    case 'watch':
    case 'device':
      return (
        <svg {...common}>
          <rect x="7" y="6" width="10" height="12" rx="3" />
          <path d="M9 6V3h6v3M9 18v3h6v-3" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...common}>
          <path d="M12 3 5 6v6c0 4 3 7 7 9 4-2 7-5 7-9V6z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case 'target':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1" />
        </svg>
      );
    case 'back':
      return (
        <svg {...common}>
          <path d="M15 5l-7 7 7 7" />
        </svg>
      );
    case 'close':
      return (
        <svg {...common}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case 'star':
      return (
        <svg {...common}>
          <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z" />
        </svg>
      );
    case 'doc':
      return (
        <svg {...common}>
          <path d="M6 3h8l4 4v14H6z" />
          <path d="M14 3v4h4M9 12h6M9 16h6" />
        </svg>
      );
    case 'coin':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8" />
          <path d="M12 8v8M9.5 10.5c0-1 1-1.5 2.5-1.5s2.5.5 2.5 1.5-1 1.5-2.5 1.5-2.5.5-2.5 1.5 1 1.5 2.5 1.5 2.5-.5 2.5-1.5" />
        </svg>
      );
  }
}
